import { Card, Elevation } from "@blueprintjs/core";
import { FGSelectInput, FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";

import { FGSRSHCheckboxInput } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useTl } from "../../../../hooks";
import { useReferential } from "../../../../hooks/useReferential";
import { ETLCodes } from "../../../../locales";

export interface IDrupalPuppyInfoBoxProps {
  name: string;
  chipNumberFG: string;
  index: number;
  pedigreeFG: string;
  breedFG: string;
  colorFG: string;
  sex: string;
  availabilityFG: string;
}

const MainContainer = styled(Card)`
  width: 70rem;
  height: 12rem;
  padding: 0px;
  margin: auto;
  margin-bottom: 1rem !important;
  display: flex;
  flex-direction: row;
`;

const Container = styled.div`
  height: 12rem;
  width: 70rem;
  margin-left: 0.5rem;
  background-color: #ffffff;
  border-radius: 3px;
`;

export const DrupalPuppyInfoBox: React.FunctionComponent<IDrupalPuppyInfoBoxProps> = ({
  name,
  index,
  chipNumberFG,
  pedigreeFG,
  breedFG,
  colorFG,
  availabilityFG,
}) => {
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();

  const [breeds, breedLoading] = useReferential((a) => a.getBreeds(null));
  const [colors, colorLoading] = useReferential((a) => a.getColors(currentLanguage.languageId));

  return (
    <MainContainer interactive={true} elevation={Elevation.FOUR}>
      <Container>
        <h2 style={{ fontSize: "25px", marginLeft: "3rem", marginBottom: "1rem" }}>{`${
          name === "" || name === null ? "Puppy #" + (index + 1) : name
        }`}</h2>
        <div style={{ marginLeft: "2rem" }}>
          <FieldGroup columns={2}>
            <FGTextInput name={pedigreeFG} label={t(ETLCodes.Pedigree)} />
            <FGSelectInput items={breeds} loading={breedLoading} name={breedFG} label={t(ETLCodes.Breed)} />
            <FGTextInput name={chipNumberFG} label={t(ETLCodes.Chip)} />
            <FGSelectInput items={colors} loading={colorLoading} name={colorFG} label={t(ETLCodes.Color)} />
            <FGSRSHCheckboxInput label={t(ETLCodes.Availability)} name={availabilityFG} />
          </FieldGroup>
        </div>
      </Container>
    </MainContainer>
  );
};
